<div class="searchbox-container">
    @if (!loading) {
        <fa-icon [icon]="['fas', 'search']"></fa-icon>
    } @if (loading) {
        <fa-icon [icon]="['fas', 'spinner']" [pulse]="true"></fa-icon>
    }

    <input
        #autoCompleteInput
        ac-keydown
        type="text"
        [placeholder]="configuration.placeholder"
        [formControl]="formControl"
        [matAutocomplete]="auto"
        autocomplete="off"
        (keyup.escape)="autoCompleteInput.blur(); clearControl()"
    />

    <mat-autocomplete
        autoActiveFirstOption
        #auto="matAutocomplete"
        (optionSelected)="onSelect($event)"
        [displayWith]="displayValue"
        class="search-autocomplete"
    >
        @if (options && options.length) {
            @for (group of options; track group) {
                <mat-optgroup [label]="getGroupLabel(group[0].key) + ':'">
                    @for (option of group; track tracker($index, option)) {
                        <mat-option [value]="option" class="ras-searchbox-item">
                            <div class="option-value">
                                @if (configuration.icons[ option.key ]) {
                                    <fa-icon
                                        [icon]="['fas', configuration.icons[option.key]]"
                                    ></fa-icon>
                                }
                                <span
                                    class="result-field-value"
                                    [innerHTML]="option.label"
                                ></span>
                            </div>
                            @if (option.count) {
                                <span class="option-count">{{ option.count }}</span>
                            }
                        </mat-option>
                    }
                </mat-optgroup>
            }
        } @if (options && !options.length && searchText) {
            <mat-option disabled [innerHTML]="configuration.noResults"></mat-option>
        }
    </mat-autocomplete>
    @if (configuration.inlineStyles) {
        <div ras-inject-content [styles]="configuration.inlineStyles"></div>
    }
</div>
